import { responsiveClassNames } from "../../utilities/props.js";
import s from "./radius.module.css";
const getRadiusStyles = (value) => {
    if (!value)
        return null;
    return {
        classNames: [s.root, ...responsiveClassNames(s, "--radius", value)],
    };
};
export default getRadiusStyles;
